module.exports = __webpack_public_path__ + "img/components (4).e2f70153.png";